import { Link } from "react-router";
import { buttonVariants } from "@/components/ui/Button";
import { tr } from "@/i18n/i18n";

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center">
      <p className="font-display text-4xl font-bold text-muted">404</p>
      <h1 className="text-xl font-semibold">{tr("Page not found")}</h1>
      <Link to="/" className={buttonVariants({ variant: "secondary" })}>
        {tr("Go to my workspace")}
      </Link>
    </div>
  );
}
